(function (ng, $) {
    //service that retrieves "bucket" results of product/facets/etc.
    //binds to ~/packages/bucket-results endpoint

    var DEFAULT_SORT_PROPERTY = '$index';

    function arraysEqual(a, b) {
        /// <summary>
        /// helper method to check for array equality
        /// </summary>
        /// <param name="a" type="type">the first array</param>
        /// <param name="b" type="type">the second array</param>
        /// <returns type="Boolean">Returns true if the arrays are found to be equal</returns>
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length != b.length) return false;

        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    ng.module('evo.Packages.Services').factory('bucketResultsService', ['$http', 'customerPackageService', 'PACKAGES_SERVICE_BASE',
        function ($http, customerPackageService, PACKAGES_SERVICE_BASE) {
            var compatibleItemMap = {},
                selectedItemsByBucketId = {},
                request = {
                    PackageBucketId: 0,
                    Facets: [],
                    InitialPackageBucketId: 0,
                    SelectedItemIds: []
                };

            //load our state from the query string parameters that are present in the url
            (function () {
                var customerPackage = customerPackageService.getCustomerPackage();
                request.PackageBucketId = request.InitialPackageBucketId = customerPackage.PackageBucketId;
                request.SelectedItemIds = customerPackage.SelectedItemIds;
            })();

            function buildCompatibleItemMap(products) {
                /// <summary>
                /// Builds the compatible item map from the given product results.
                /// </summary>
                /// <param name="products">The products from the results.</param>
                compatibleItemMap = {};
                if (!products || !products.length) {
                    return;
                }
                ng.forEach(products, function (product) {
                    compatibleItemMap[product.ProductPageId] = product.ItemIds;
                });
            }

            function getBucketResults() {
                /// <summary>
                /// Helper method to actually make the http call and return the deferred response
                /// </summary>
                return $http.post(PACKAGES_SERVICE_BASE + 'bucket-results', request).then(function (response) {
                    var results = response.data;

                    //update our selected item map since we don't always know the state of the items
                    selectedItemsByBucketId = {};
                    ng.forEach(results.Buckets, function (bucket) {
                        if (bucket.ChosenItem) {
                            selectedItemsByBucketId[bucket.PackageBucketId] = bucket.ChosenItem.ItemId;
                        }
                    });

                    //just in case the selected items prevent results for the bucket
                    //we need to request for results again now that we've purged the bad selected items
                    var currentItemCount = request.SelectedItemIds.length;
                    updateSelectedIds();
                    if (currentItemCount !== request.SelectedItemIds.length && !results.Products.length) {
                        return getBucketResults();
                    }

                    return results;
                });
            }

            function setCompatibleItemIds(products) {
                /// <summary>
                /// Updates the given products to have the "compatible" item ids as well as the "filtered" item ids
                /// </summary>
                /// <param name="products">The products from the results.</param>
                if (!products || !products.length) {
                    return;
                }
                ng.forEach(products, function (product) {
                    product.FilteredItemIds = product.ItemIds;
                    product.ItemIds = compatibleItemMap[product.ProductPageId];
                });
            }

            function updateSelectedIds() {
                var oldItemIds = request.SelectedItemIds;
                request.SelectedItemIds = $.map(selectedItemsByBucketId, function (v) { return v; });
                if (!arraysEqual(request.SelectedItemIds, oldItemIds)) {
                    customerPackageService.setPackageItems(request.SelectedItemIds);
                }
            }

            return {
                applyFacets: function (facets) {
                    /// <summary>
                    /// Applies the given facets to the currently viewed bucket and returns the result
                    /// </summary>
                    /// <param name="facets" type="Array">Facets to apply</param>
                    /// <returns type="Object">Returns the view model (deferred)</returns>

                    request.Facets = facets;

                    return getBucketResults().then(function (results) {
                        setCompatibleItemIds(results.Products);

                        return results;
                    });
                },
                selectItem: function (itemId) {
                    if (!itemId) {
                        console.warn('ItemId not provided. Unable to select item.');
                        return;
                    }

                    request.Facets = [];

                    selectedItemsByBucketId[request.PackageBucketId] = itemId;
                    updateSelectedIds();
                },
                removeItem: function (itemId) {
                    if (!itemId) {
                        console.warn('ItemId not provided. Unable to remove item.');
                        return;
                    }

                    for (var bucketId in selectedItemsByBucketId) {
                        if (selectedItemsByBucketId[bucketId] !== itemId)
                            continue;

                        delete selectedItemsByBucketId[bucketId];
                        request.Facets = [];
                        updateSelectedIds();
                        break;
                    }
                },
                viewBucket: function (packageBucketId) {
                    /// <summary>
                    /// Retrieves bucket results
                    /// </summary>
                    /// <param name="packageBucketId" type="Number">Bucket id to view, if provided</param>
                    /// <returns type="Object">Returns the view model (deferred)</returns>

                    request.Facets = [];

                    if (packageBucketId) {
                        request.PackageBucketId = packageBucketId;
                    }

                    return getBucketResults().then(function (results) {
                        buildCompatibleItemMap(results.Products);

                        return results;
                    });
                }
            };
        }
    ]);
})(angular, jQuery);